import {FC} from "react";
import styled from "@emotion/styled";
import {useTranslation} from "react-i18next";
import {getAllStarLogo} from "modules/utils";
import {Footer, Header} from "components";
import bg from "assets/images/votePeriod/bg.png";
import mobileBg from "assets/images/votePeriod/mobileBg.png";
import {breakpoints} from "assets/theme";

const Wrapper = styled.div`
	width: 100%;
	height: 100%;
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	color: ${({theme}) => theme.colorPalette.white};
`;

const Container = styled.div`
	background: url(${mobileBg}) no-repeat center;
	background-color: #151515;
	background-size: 100% 100%;
	width: 100%;
	flex-grow: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 16px;
	text-align: center;

	@media (min-width: ${breakpoints.medium}) {
		background-image: url(${bg});
		background-size: cover;
	}
`;

const Logo = styled.img`
	width: 157px;
	height: auto;
	margin-bottom: 20px;

	@media (min-width: ${breakpoints.medium}) {
		margin-bottom: 40px;
		width: 300px;
	}
`;

const Title = styled.h1`
	font-size: 28px;
	font-weight: 700;
	line-height: 120%;
	letter-spacing: 0.2px;
	text-transform: uppercase;
	margin-bottom: 8px;

	@media (min-width: ${breakpoints.medium}) {
		margin-bottom: 16px;
		font-size: 32px;
	}
`;

const Desc = styled.p`
	font-size: 14px;
	font-weight: 700;
	line-height: 120%;
	letter-spacing: 0.32px;

	@media (min-width: ${breakpoints.medium}) {
		font-size: 16px;
	}
`;

export const VotePeriod: FC = () => {
	const {t, i18n} = useTranslation();
	const lang = i18n.language;
	const logo = getAllStarLogo(lang);

	return (
		<Wrapper>
			<Header />

			<Container>
				{/*<Content>*/}
				<Logo src={logo} alt="All-Star logo" />
				<Title>{t("page.vote_period.closed")}</Title>
				<Desc>{t("page.vote_period.desc")}</Desc>
				{/*</Content>*/}
			</Container>

			<Footer />
		</Wrapper>
	);
};
